/** Milliseconds to coalesce rapid duplicate effect runs (same params) when risk free / filters update. */
export const STRIKE_REQUEST_DEBOUNCE_MS = 500;

export function normalizeStickyStrikeRiskFree(value) {
  if (value === undefined || value === null || value === "") {
    return undefined;
  }
  const n = typeof value === "number" ? value : Number(value);
  return Number.isFinite(n) ? n : undefined;
}

/**
 * Pick risk-free from filters first, then fallback (e.g. control-table context),
 * always as a finite number so effect deps / query params stay stable (avoids `"5"` vs `5`).
 */
export function mergeStickyStrikeRiskFree(filterRiskFree, fallbackRiskFree) {
  const raw =
    filterRiskFree !== undefined &&
    filterRiskFree !== null &&
    filterRiskFree !== ""
      ? filterRiskFree
      : fallbackRiskFree !== undefined &&
          fallbackRiskFree !== null &&
          fallbackRiskFree !== ""
        ? fallbackRiskFree
        : undefined;

  return normalizeStickyStrikeRiskFree(raw);
}

/** Normalized product ID for URLs (shortcut sometimes gives number, sometimes string). */
export function normalizeProductContractStyleId(productId) {
  if (productId === undefined || productId === null || productId === "") {
    return undefined;
  }
  const id = typeof productId === "number" ? productId : String(productId).trim();
  return id === "" ? undefined : id;
}

export function findVolSurfaceShortcutByPcsId(shortcuts, productContractStyleId) {
  const target = normalizeProductContractStyleId(productContractStyleId);
  if (target == null || !Array.isArray(shortcuts)) return null;
  return (
    shortcuts.find(
      (item) =>
        normalizeProductContractStyleId(item?.product_contract_style_id) ===
        target
    ) ?? null
  );
}

/** Filter patch when the user picks a vol-surface PCS shortcut tab. */
export function selectedFiltersPatchForVolSurfaceShortcut(shortcutItem) {
  const pcsId = shortcutItem?.product_contract_style_id;
  if (pcsId == null) return null;
  return {
    product_id: pcsId,
    shortcutFilter: pcsId,
    comparison_surface_id: null,
    live_surface_id: null,
    risk_free: null,
    average: null,
    cost_of_carry: null,
    shortcut_name: shortcutItem.label,
  };
}
